export default "__VITE_ASSET__DnJxj3Wy__"